import React from 'react';
import styles from './WorkFlowHeader.module.scss';
import Button from 'component/atom/forms/button/Button';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useBrandingContext } from 'app-context/BrandingsContext';
import { useNavigate } from 'react-router-dom';

const WorkflowHeader = ({
  onSave,
  backgroundColor,
  data,
  isPending,
  id,
  resetWorkflowData,
  setFlag,
  handleBack,
}) => {
  // const handleBack = () => {
  //   setFlag(false);
  //   window.location.href = `/bot/workflow/${data?.data?.botId}`;
  //   // navigate(`/bot/workflow/${data?.data?.botId}`);
  //   // window.location.reload();
  //   setTimeout(() => {
  //     resetWorkflowData();
  //   }, [500]);
  // };
  const handleSave = () => {
    if (onSave) onSave();
  };
  return (
    <div className={styles['flow-header']} style={{ backgroundColor }}>
      <div className={styles['icon-container']}>
        <SvgWithBranding
          type='back'
          onClick={handleBack}
          className={styles.icon}
          color='white'
        />
      </div>

      <h1>
        {data?.data?.botName || ''}
        <span>
          {data?.data?.botName && data?.data?.name ? '-' : null}
          {data?.data?.name || ''}
        </span>
      </h1>
      <div className={styles['button-container']}>
        <Button
          buttonType='button'
          label='Save'
          className={styles['button']}
          onClick={handleSave}
          isLoading={isPending}
        />
      </div>
    </div>
  );
};

export default WorkflowHeader;
